import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"padding-bottom":"200px"}
}
const _hoisted_3 = { slot: "content" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Aucun résultat", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_EquipmentSkeleton = _resolveComponent("EquipmentSkeleton")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_UnitySelector = _resolveComponent("UnitySelector")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ContentSidebarWrapper = _resolveComponent("ContentSidebarWrapper")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_EquipmentSelectorButton = _resolveComponent("EquipmentSelectorButton")!
  const _component_UserSelectorButton = _resolveComponent("UserSelectorButton")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "Retour",
                    "default-href": `/report-sheets/${_ctx.sheet?.uuid}`
                  }, null, 8, ["default-href"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Rapport : " + _toDisplayString(_ctx.sheet?.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['sub-header'])
      }, "Matériel (" + _toDisplayString(_ctx.sheet?.equipments.length ?? 0) + ")", 3),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ContentSidebarWrapper, { side: "left" }, _createSlots({
            content: _withCtx(() => [
              (!_ctx.loaded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_EquipmentSkeleton)
                  ]))
                : (_ctx.sheet?.equipments?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_ion_accordion_group, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheet?.equipments, (equipment) => {
                            return (_openBlock(), _createBlock(_component_ion_accordion, {
                              key: equipment.uuid,
                              value: equipment.uuid
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  slot: "header",
                                  color: "light"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(equipment?.reference) + " - " + _toDisplayString(equipment?.name) + " ", 1),
                                        (equipment.total_cost )
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: _normalizeClass(_ctx.$style['total_cost'])
                                            }, "Total : " + _toDisplayString(equipment.total_cost ?? 0.00) + "€", 3))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("div", _hoisted_3, [
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_UnitySelector, {
                                        onIonChange: ($event: any) => (_ctx.handleUnity(equipment, $event)),
                                        disabled: _ctx.fieldDisabled,
                                        modelValue: equipment.unity,
                                        "onUpdate:modelValue": ($event: any) => ((equipment.unity) = $event)
                                      }, null, 8, ["onIonChange", "disabled", "modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_input, {
                                        disabled: _ctx.fieldDisabled,
                                        label: "Quantité :",
                                        placeholder: "Enter data",
                                        modelValue: equipment.quantity,
                                        "onUpdate:modelValue": ($event: any) => ((equipment.quantity) = $event),
                                        onChange: ($event: any) => (_ctx.calculateTotalDailyCost(equipment))
                                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_input, {
                                        onClick: ($event: any) => (_ctx.triggerUserSelector(equipment)),
                                        disabled: _ctx.fieldDisabled,
                                        label: "Employé :",
                                        placeholder: "Select data",
                                        value: `${equipment.employee_firstname} ${equipment.employee_lastname}`
                                      }, null, 8, ["onClick", "disabled", "value"]),
                                      (equipment.employee_firstname || equipment.employee_lastname)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: _normalizeClass(_ctx.$style['container-button-remove-employee'])
                                          }, [
                                            _createVNode(_component_ion_button, {
                                              fill: "outline",
                                              size: "small",
                                              onClick: ($event: any) => (_ctx.removeEmployee(equipment)),
                                              slot: "end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, {
                                                  class: _normalizeClass(_ctx.$style['icon-remove-employee']),
                                                  icon: _ctx.personRemoveOutline
                                                }, null, 8, ["class", "icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ], 2))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (_ctx.user.rights?.includes('report_sheets.manager'))
                                    ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_input, {
                                            disabled: _ctx.fieldDisabled,
                                            label: equipment.unity === 'Hr' ? 'Coût horaire' : 'Coût unitaire',
                                            modelValue: equipment.hourly_cost,
                                            "onUpdate:modelValue": ($event: any) => ((equipment.hourly_cost) = $event),
                                            type: "number",
                                            onChange: ($event: any) => (_ctx.calculateTotalDailyCost(equipment))
                                          }, null, 8, ["disabled", "label", "modelValue", "onUpdate:modelValue", "onChange"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  (_ctx.user.rights?.includes('report_sheets.manager'))
                                    ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_input, {
                                            disabled: true,
                                            label: "Coût total",
                                            modelValue: equipment.total_cost,
                                            "onUpdate:modelValue": ($event: any) => ((equipment.total_cost) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  (!_ctx.fieldDisabled)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        class: _normalizeClass(_ctx.$style['container-button'])
                                      }, [
                                        false
                                          ? (_openBlock(), _createBlock(_component_ion_button, {
                                              key: 0,
                                              slot: "start",
                                              size: "small",
                                              fill: "outline",
                                              onClick: ($event: any) => (_ctx.presentActionEquipment(equipment))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Supprimer")
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ion_button, {
                                          slot: "end",
                                          size: "small",
                                          color: "success",
                                          onClick: ($event: any) => (_ctx.formSubmit(equipment))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Enregistrer")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_ion_text, {
                        class: "ion-text-center",
                        color: "medium"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]))
            ]),
            _: 2
          }, [
            (_ctx.loaded && _ctx.sheet.total_equipments_cost)
              ? {
                  name: "sidebar",
                  fn: _withCtx(() => [
                    _createElementVNode("p", {
                      class: _normalizeClass(_ctx.$style['total_day'])
                    }, "Coût total du matériel : " + _toDisplayString(_ctx.sheet.total_equipments_cost ?? 0.00) + "€", 3)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024),
          (!_ctx.sheet?.equipments_step_validated || _ctx.userCanForceEdit())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_ion_fab, {
                  slot: "fixed",
                  vertical: "bottom",
                  horizontal: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_fab_button, {
                      color: "primary",
                      onClick: _ctx.presentActionSheet
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.caretUp }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_EquipmentSelectorButton, {
                  style: {"display":"none"},
                  ref: "equipmentSelectorRef",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addEquipment($event.value))),
                  filter: { types: ['small-equipment', 'rolling-stock', 'supply'] },
                  "bypass-organization": true
                }, null, 512),
                _createVNode(_component_UserSelectorButton, {
                  style: {"display":"none"},
                  ref: "userSelectorRef",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectEmployee($event.value))),
                  "bypass-organization": true
                }, null, 512)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}